export default "__VITE_ASSET__DuCaQxV1__"